function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M47.911.47C23.956 3.615 12.17 23.225 9.938 26.758-2.26 46.075-4.709 75.337 11.018 93.91c10.394 12.276 24.771 15.21 32.21 16.726 5.036 1.028 28.736 5.235 48.766-9.198 1.704-1.228 3.86-2.782 6.14-5.192 17.272-18.262 19.1-61.928-6.588-83.543C81.315 4.094 67.829 0 55.209 0c-2.476 0-4.92.158-7.298.47",
  id: "noresult_inline_svg__gkjjzi6xqa"
}), React.createElement("path", {
  d: "M3.66 0C1.66 0 .036 2.237.035 4.996L0 85.098c-.001 2.738 1.595 4.968 3.58 5.002l72.038 1.248c2.716.046 4.95-2.94 5-6.686L81.663 5.09C81.7 2.294 80.067 0 78.04 0H3.66z",
  id: "noresult_inline_svg__xdjkjc5yjb"
}), React.createElement("path", {
  d: "M1.471 38.609a4.132 4.132 0 00-.322 6.02l.27.283a3.759 3.759 0 005.368.064l41.577-39.09L43.044 0 1.471 38.609z",
  id: "noresult_inline_svg__va4w1wqfad"
}), React.createElement("path", {
  d: "M19.354 1.733C4.278 7.136-3.652 23.542 1.642 38.378c5.293 14.835 21.806 22.482 36.882 17.08C53.6 50.056 61.53 33.65 56.237 18.814 52.095 7.207 41.086 0 29.27 0c-3.287 0-6.635.558-9.917 1.733M5.652 36.941C1.136 24.284 7.9 10.288 20.762 5.679c12.862-4.608 26.949 1.915 31.465 14.572 4.516 12.656-2.25 26.652-15.11 31.261a25.048 25.048 0 01-8.46 1.479c-10.081 0-19.472-6.148-23.005-16.05",
  id: "noresult_inline_svg__y15xduuxne"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M92.821.794c2.186 0 3.947 2.454 3.907 5.445L95.6 91.346c-.053 4.005-2.46 7.2-7.386 7.15l-75.89-1.303A3.146 3.146 0 019.477 95.3c-.4-.937-.756-2.157-.756-3.488L8.76 6.138c0-2.952 1.749-5.344 3.906-5.344H92.82z",
  fill: "#EAEAEA"
}), React.createElement("g", {
  transform: "translate(11.893 3.177)"
}, React.createElement("mask", {
  id: "noresult_inline_svg__k3pb9wdmhc",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#noresult_inline_svg__xdjkjc5yjb"
})), React.createElement("path", {
  d: "M3.66 0C1.66 0 .036 2.237.035 4.996L0 85.098c-.001 2.738 1.595 4.968 3.58 5.002l72.038 1.248c2.716.046 4.95-2.94 5-6.686L81.663 5.09C81.7 2.294 80.067 0 78.04 0H3.66z",
  fill: "#F2F2F2",
  mask: "url(#noresult_inline_svg__k3pb9wdmhc)"
})), React.createElement("path", {
  d: "M93.557 14.638H11.893V3.462c0-.596.482-1.079 1.076-1.079h79.572c.561 0 1.016.456 1.016 1.018v11.237z",
  fill: "#EAEAEA"
}), React.createElement("path", {
  d: "M89.804 21.962H15.641a.89.89 0 01-.89-.89v-2.38a.89.89 0 01.898-.89l74.163.655a.89.89 0 01.883.89v1.725a.89.89 0 01-.89.89M33.365 9.063a2.191 2.191 0 010-4.383 2.19 2.19 0 010 4.383m-7.085.167a2.191 2.191 0 010-4.384 2.191 2.191 0 010 4.383m-6.81.001a2.191 2.191 0 010-4.384 2.191 2.191 0 010 4.383",
  fillOpacity: 0.5,
  fill: "#FFF"
}), React.createElement("path", {
  d: "M63.477 54.408l-20.421-.17a1.251 1.251 0 01-1.24-1.264l.17-20.506c.007-.68.551-1.23 1.229-1.242l20.165.383a1.56 1.56 0 011.529 1.576l-.172 19.98a1.251 1.251 0 01-1.26 1.243",
  fillOpacity: 0.8,
  fill: "#FFF"
}), React.createElement("path", {
  d: "M37.617 54.408l-21.224-.17c-.717-.006-1.294-.572-1.288-1.264l.177-20.506c.006-.68.572-1.23 1.276-1.242l20.959.383c.887.017 1.596.72 1.588 1.576l-.178 19.98c-.006.692-.593 1.248-1.31 1.243",
  fillOpacity: 0.5,
  fill: "#FFF"
}), React.createElement("path", {
  d: "M89.358 54.893l-20.422-.17a1.251 1.251 0 01-1.239-1.264l.17-20.506a1.25 1.25 0 011.228-1.242l20.166.383a1.56 1.56 0 011.528 1.576l-.172 19.98a1.251 1.251 0 01-1.26 1.243",
  fillOpacity: 0.8,
  fill: "#FFF"
}), React.createElement("path", {
  d: "M90.295 71.612a2.462 2.462 0 01-2.495 2.464l-70.92-1.042a2.165 2.165 0 01-2.13-2.167V58.533c0-1.205.98-2.178 2.18-2.168l71.222.603a2.164 2.164 0 012.143 2.11v12.534zM87.283 82.61L16.7 81.7a1.976 1.976 0 01-1.948-1.979v-2.88c0-.738.602-1.335 1.339-1.325l72.736.96c1.036.014 1.87.86 1.87 1.9v.857a3.373 3.373 0 01-3.413 3.377",
  fillOpacity: 0.5,
  fill: "#FFF"
}), React.createElement("path", {
  d: "M7.37 111.035c-1.7 1.427-1.838 4.016-.301 5.62l.252.263a3.49 3.49 0 004.993.06L51 80.494 46.05 75 7.37 111.035z",
  fill: "#0558E6"
}), React.createElement("path", {
  d: "M96.326 46.08c5.397 15.045-2.687 31.683-18.055 37.162-15.368 5.479-32.201-2.276-37.597-17.322-5.397-15.045 2.687-31.683 18.055-37.162 15.369-5.479 32.201 2.276 37.597 17.322",
  fillOpacity: 0.5,
  fill: "#FFF"
}), React.createElement("path", {
  d: "M57.736 25.94c-16.931 6.045-25.837 24.405-19.892 41.006 5.945 16.602 24.49 25.16 41.42 19.114 16.931-6.045 25.837-24.404 19.892-41.006C94.506 32.065 82.141 24 68.873 24a33.07 33.07 0 00-11.137 1.94M42.347 65.338c-5.072-14.163 2.526-29.825 16.97-34.983 14.444-5.157 30.264 2.144 35.336 16.307 5.072 14.163-2.526 29.825-16.97 34.983a28.22 28.22 0 01-9.5 1.654c-11.322.001-21.868-6.88-25.836-17.96",
  fill: "#0558E6"
}));

function SvgNoresultinline(props) {
  return React.createElement("svg", _extends({
    width: 111,
    height: 118,
    viewBox: "0 0 111 118"
  }, props), _ref, _ref2);
}

export default SvgNoresultinline;